import { ValueOf } from 'common/types'

export const REGION_SEARCH_PARAM = 'region'

export const Region = {
  EU: 'eu',
  IN: 'in',
}
export type Region = ValueOf<typeof Region>

const DEFAULT_REGION: Region = Region.EU

export const RegionStore = (() => {
  const searchParams = new URLSearchParams(window.location.search)
  let currentRegion: Region = searchParams.get(REGION_SEARCH_PARAM) ?? DEFAULT_REGION

  return {
    get region() {
      return currentRegion
    },

    setRegion(newRegion: Region) {
      currentRegion = newRegion
    },
  }
})()
